import React from "react";

interface ToolCardDiffProps {
  additions: number;
  deletions: number;
}

export const ToolCardDiff: React.FC<ToolCardDiffProps> = ({ additions, deletions }) => {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-mono">
      {additions > 0 && (
        <span className="text-green-600">+{additions}</span>
      )}
      {deletions > 0 && (
        <span className="text-red-500">-{deletions}</span>
      )}
    </span>
  );
};
